import { FC, useCallback } from 'react';
import { Box } from '@mui/material';
import LockedIcon from '@mui/icons-material/LockOutlined';
import { useLanguage } from 'context/AppContext';
import theme from 'App.theme';
import { useSendSubscriptionUpgradeRequest } from 'api/hooks/useSendSubscriptionUpgradeRequest';
import Button from './Button';
import { toast } from 'react-toastify';

const FeatureUnavailableNotice: FC<{ onUpgradeRequest?: VoidFunction }> = ({ onUpgradeRequest }) => {
  const lang = useLanguage()[0].FeatureUnavailableNotice;

  const { mutateAsync: sendSubscriptionUpgradeRequest, isLoading } = useSendSubscriptionUpgradeRequest();

  const handleUpgradeRequest = useCallback(async () => {
    try {
      await sendSubscriptionUpgradeRequest({ sourcePage: window?.location.href || '' });
    } catch (error) {
      console.error('Error sending subscription upgrade request:', error);
    } finally {
      toast.success(lang.successMessage);
      onUpgradeRequest && setTimeout(onUpgradeRequest, 400);
    }
  }, [sendSubscriptionUpgradeRequest, lang.successMessage, onUpgradeRequest]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.layout.spacing.medium,
        m: theme.layout.spacing.medium,
        alignItems: 'center',
        justifyContent: 'center',
        '& path': {
          stroke: theme.colors.amberLight,
          strokeWidth: '0.75px',
        },
      }}
    >
      <LockedIcon style={{ fontSize: 100, color: theme.colors.amberDark }} />
      <Box mt={2} style={{ fontSize: 20, textAlign: 'center' }}>
        <div>{lang.featureIsOff}</div>
        <p>{lang.learnMoreBelow}</p>
      </Box>
      <Button label={lang.learnMore} colors="white on primary" onClick={handleUpgradeRequest} disabled={isLoading} />
    </Box>
  );
};

export default FeatureUnavailableNotice;
